<template>
    <div>
        <div v-if="loadingHistory" class="pa-5 d-flex align-center justify-center">
            <loader/>
        </div>
        <div v-else-if="!history || !history.length" class="pa-2 text-overline grey--text text-center">
            No Warning History
        </div>
        <div v-else>
            <v-data-table
                :items="history"
                :headers="headers"
                dense
            >
                <template #item.status="{item}">
                    <v-icon>{{item.status === 'signed' ? 'mdi-check-all' : 'mdi-timer'}}</v-icon>
                </template>
                <template #item.issued="{item}">
                    {{format(new Date(item.issued), 'yy-MM-dd hh:mm')}}
                </template>
                <template #item.offenceTitle="{item}">
                    <span class="caption">{{item.offenceTitle.replace(/^"|"$/gm, '')}}</span>
                </template>
                <template #item.action="{item}">
                    <v-btn
                        icon
                        small
                        :disabled="item.status !== 'signed' || fetchingWarning"
                        :loading="fetchingWarning"
                        @click="downloadWarning(item)"
                        color="secondary"
                    >
                        <v-icon>mdi-download</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {waitForEvent} from "../../../core/socket";
import {validationRules} from "../../../core/codeFunctions";
import Loader from "@/components/General/Loader/Loader.vue";
import {format} from "date-fns";

export default {
    components: {Loader},
    props: {
        fkEmp: Number
    },
    data() {
        return {
            format,
            loadingHistory: false,
            history: null,
            headers: [
                {value: "status", text: "", width: 20},
                {value: "issued", text: "Issued"},
                {value: "warning", text: "Warning"},
                {value: "offenceTitle", text: "Charge"},
                {value: "action", text: "", width: 30},
            ],
            fetchingWarning: false
        }
    },
    watch: {

        fkEmp: {
            immediate: true,
            handler() {
                this.initHistory();
            }
        }

    },
    methods: {


        async downloadWarning(row) {
            try {
                this.fetchingWarning = true;
                await this.$newReqDownloadFile("POST",'setup/emp/getWarning', {id: row.fkSignedDoc}, `${row.empCode} ${row.warning} ${format(new Date(row.issued), 'yy-mm-dd')}.pdf`)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.fetchingWarning = false
            }
        },

        async initHistory() {
            try {
                this.loadingHistory = true;
                this.history = await this.$newReq("POST",'setup/emp/warningHistory', {id: this.fkEmp}, )
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.loadingHistory = false
            }
        },

    },
    computed: {
        ...mapGetters(['barcodes', 'barcodesLookup']),
    },
}
</script>

<style scoped>

</style>